import {
  TEMPLATES as SERVICE_WORKER_TEMPLATES,
  TemplateDescriptions as SERVICE_WORKER_TemplateDescriptions,
  VERSIONS as SERVICE_WORKER_VERSIONS
} from '../../../../ServiceWorker/src/constants/templates.constants';

export { SERVICE_WORKER_TEMPLATES as TEMPLATES };
export { SERVICE_WORKER_TemplateDescriptions as TemplateDescriptions };
export { SERVICE_WORKER_VERSIONS as VERSIONS };
